import React from "react";
import { useNavigate } from "react-router-dom";
import OnboardingCuate from "../../assets/images/Onboarding-cuate.svg";
import DashboardHeaderWithNoData from "./DashboardHeaderWithNoData";

function DashboardWithNoData() {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/q1");
    };
    return (
        <>
            <DashboardHeaderWithNoData />
            <div className="dashboard-body">
                <div className="no-data-dashboard-body text-center">
                    <h3>Help us know you better</h3>
                    <div>
                        <img src={OnboardingCuate} alt="" />
                    </div>
                    <button
                        type="submit"
                        className="as-btn-primary"
                        onClick={handleClick}
                    >
                        Start Onboarding
                    </button>
                </div>
            </div>
        </>
    )
}

export default DashboardWithNoData
